import React from 'react';
import HomeHero from '../components/home/homehero';
import AboutUs from '../components/home/AboutUs';
import WhyChooseUs from '../components/home/WhyChooseUs';
import CoreMission from '../components/home/CoreMission';
import FeaturedListings from '../components/home/FeaturedListings';
import InquiryForm from '../components/home/InquiryForm';
import Newsletter from '../components/home/Newsletter';
import Seo from '../components/seo/Seo';

const Home: React.FC = () => {
  return (
    <main className="min-h-screen bg-white">
      <Seo
        title="Dubai & USA Real Estate Investments"
        description="Hogar Dorado House connects investors with premium Dubai and USA real estate opportunities, curated advisory, and a dual-market investment strategy."
        pathname="/"
        keywords={[
          'Hogar Dorado House',
          'Dubai real estate',
          'USA real estate',
          'America real estate',
          'property investment',
          'off plan Dubai',
          'buy house in Dubai',
          'buy property in Dubai',
          'buy property in USA',
          'Dubai luxury homes',
          'most extravagant properties',
          'best Dubai properties',
          'best USA properties',
          'Dubai villas for sale',
          'America houses for sale',
          'luxury real estate investments'
        ]}
      />
      <HomeHero />
      <AboutUs />
      <WhyChooseUs />
      <CoreMission />
      <FeaturedListings />
      <InquiryForm />
      <Newsletter />
    </main>
  );
};

export default Home;